import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  pulse?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  pulse = false,
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center font-extrabold rounded-full transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white overflow-hidden cursor-pointer select-none uppercase tracking-wide';
  const variants = {
    primary: 'bg-gradient-to-r from-orange-500 via-red-500 to-orange-600 text-white hover:from-orange-400 hover:via-red-400 hover:to-orange-500 shadow-[0_6px_30px_rgba(239,68,68,0.45)] hover:shadow-[0_8px_45px_rgba(239,68,68,0.65)]',
    secondary: 'bg-gradient-to-r from-brand-purple via-purple-600 to-brand-purple text-white hover:from-purple-500 hover:via-brand-purple hover:to-purple-500 shadow-[0_6px_30px_rgba(123,63,160,0.4)] hover:shadow-[0_8px_45px_rgba(123,63,160,0.6)]',
    outline: 'border-2 border-slate-800 text-slate-800 hover:bg-slate-800 hover:text-white'
  };
  const sizes = {
    sm: 'px-5 py-2.5 text-sm',
    md: 'px-7 py-3.5 text-base',
    lg: 'px-9 py-4 text-lg',
    xl: 'px-12 py-6 text-xl'
  };
  const pulseClass = pulse ? 'animate-glow-pulse' : '';
  const widthClass = fullWidth ? 'w-full' : '';
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.96
  }} transition={{
    type: 'spring',
    stiffness: 400,
    damping: 15
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${pulseClass} ${widthClass} ${className}`} {...props} data-id="element-388">
      {/* Shine sweep */}
      <span className="absolute inset-0 overflow-hidden rounded-full pointer-events-none" data-id="element-389">
        <span className="absolute -left-full top-0 w-1/2 h-full bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-[-20deg] animate-[shine_2.5s_ease-in-out_infinite]" data-id="element-390" />
      </span>
      {/* Top edge highlight */}
      <span className="absolute inset-x-0 top-0 h-[2px] bg-white/25 rounded-full pointer-events-none" data-id="element-391" />
      {/* Bottom edge depth */}
      <span className="absolute inset-x-0 bottom-0 h-[2px] bg-black/15 rounded-full pointer-events-none" data-id="element-392" />
      <span className="relative z-10 flex items-center justify-center gap-1 drop-shadow-sm" data-id="element-393">
        {children}
      </span>
    </motion.button>;
}